var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.connections, loading: _vm.$apollo.loading } },
        [
          _vm.empty
            ? _c("EmptyListPlaceholder", {
                attrs: { title: "You do not have any connections yet" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "image",
                      fn: function () {
                        return [_c("EmptyListImageConnections")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2801342586
                ),
              })
            : _c("TableContainer", {
                attrs: { config: _vm.config },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function () {
                      return _vm._l(_vm.contractorConnections, function (user) {
                        return _c("ConnectionTableItem", {
                          key: user.id,
                          attrs: {
                            cols: _vm.config.headers.length,
                            user: user,
                          },
                        })
                      })
                    },
                    proxy: true,
                  },
                ]),
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }